export default "__VITE_ASSET__CKQgUfcH__"